<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout
      v-show="$route.matched.length == 2"
      :class="this.isShow ? 'filterBlur' : ''"
    >
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="输入结算周期/备注"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="结算方式">
              <el-select
                v-model="searchCondition.salary_type"
                placeholder="请选择结算方式"
                clearable
              >
                <el-option
                  v-for="item in salaryTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="String(item.value)"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" :disabled="disabled" />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchButton"
                :disabled="disabled"
                >查询</el-button
              >
              <el-button
                style="margin-left: 24px;"
                :loading="downloadLoading"
                type="primary"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item"
          >
          </el-tab-pane>
        </el-tabs>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            slot="first-column"
            width="150"
            align="center"
            label="任务名称"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.task_name"
                placement="top"
                >
                <div>{{ scope.row.task_name || "-" }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="结算单"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.settlement_file_url">
                <el-button
                  size="mini"
                  type="text"
                  :disabled="disabled"
                  @click="mxPreview(scope.row.settlement_file_url)"
                >
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  :disabled="disabled"
                  @click="mxGoUrl(scope.row.settlement_file_url)"
                >
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="buttonType == 'text'"
            width="260"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="danger"
                  v-if="
                    scope.row.status === 0 &&
                      userPermissions.indexOf('task_grant') != -1
                  "
                  @click="viewButton(scope.row.id, 'send')"
                  :disabled="disabled"
                  >提交发放</el-button
                >
                <el-popover
                  placement="top"
                  width="150"
                  v-if="
                    scope.row.status === 0 &&
                      userPermissions.indexOf('task_grant') != -1
                  "
                  v-model="scope.row.visiblePass"
                >
                  <p>确定要作废吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visiblePass = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="changeStatus(scope.row.id, 'cancel')"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    size="mini"
                    type="info"
                    :disabled="disabled"
                    >作废批次</el-button
                  >
                </el-popover>
                <el-button
                  size="mini"
                  type="primary"
                  v-if="userPermissions.indexOf('task_detail') != -1"
                  @click="viewButton(scope.row.id)"
                  :disabled="disabled"
                  >发放明细</el-button
                >
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog
      :dialogData="dialogData"
      :showButton="showButton"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <div
          :class="this.signTipsInfo.type == 1 ? 'warning-tips' : 'error-tips'"
        >
          <el-alert
            :class="signTipsInfo.message.length == 1 ? 'tips-center' : ''"
            :title="tipsTitle"
            :type="fontType"
            :description="''"
            :show-icon="true"
            :closable="false"
          >
            <template name="—">
              <span>
                <div v-for="(item, index) in this.description" :key="index">
                  {{ item }}
                </div>
              </span>
            </template>
          </el-alert>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ModalDialog from "@/components/ModalDialog";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters } from "vuex";
import { SALARY_TYPE_LIST } from "@/utils/utils";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    DatePicker,
  },
  data() {
    return {
      disabled: false,
      showButton: ["cancel", "determine"], // 不显示弹窗框的按钮
      activeName: "all",
      salaryTypeOptions: SALARY_TYPE_LIST,
      tabsList: [
        {
          label: "正常批次",
          name: "all",
        },
        {
          label: "已作废",
          name: "cancel",
        },
      ],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [
        {
          title: "结算方式",
          value: "alias_salary_type",
          header_align: "center",
          align: "center",
          width: 120,
        },
        {
          title: "结算金额",
          value: [
            { label: "总金额：", value: "total_amount" },
            { label: "人员数：", value: "total_num" },
          ],
          header_align: "center",
          width: 180,
        },
        {
          title: "实收金额",
          value: "actual_amount",
          header_align: "center",
          align: "center",
          width: 120,
        },
        {
          title: "预抵税费合计",
          value: "estimated_tax_amount",
          header_align: "center",
          align: "center",
          width: 140,
        },
        {
          title: "预扣增值税和附加税",
          value: "added_tax_amount",
          header_align: "center",
          align: "center",
          width: 170,
        },
        {
          title: "成功金额",
          value: "succeed_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "失败金额",
          value: "failed_amount",
          header_align: "center",
          align: "center",
        },
        {
          title: "发放状态",
          value: "send_status",
          header_align: "center",
          align: "center",
        },
        {
          title: "批次状态",
          value: "alias_status",
          header_align: "center",
          align: "center",
        },
        {
          title: "生成时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
        {
          title: "提交时间",
          value: "submit_time",
          header_align: "center",
          align: "center",
        },
      ],
      dataList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      dialogData: {
        visible: false,
        title: "系统提示",
        width: "35%",
        loading: false,
        modal: false,
      },
      signTipsInfo: {
        type: 0,
        message: [],
      },
      fontType: "",
      isShow: false, //是否模糊页面
      tipsTitle: "",
      description: [],
      downloadLoading: false,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
  },
  watch: {
    "$route.matched": function(n) {
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    async handleDownload() {
      this.downloadLoading = true;
      let list = this.dataList;
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = [
          "任务名称",
          "结算单",
          "结算方式",
          "结算总金额",
          "结算人员数",
          "实收金额",
          "预抵税费合计",
          "预扣增值税和附加税",
          "成功金额",
          "失败金额",
          "发放状态",
          "批次状态",
          "生成时间",
          "提交时间",
        ];
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `任务结算${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          task_name,
          settlement_sheet,
          alias_salary_type,
          total_amount,
          total_num,
          actual_amount,
          estimated_tax_amount,
          added_tax_amount,
          succeed_money,
          failed_amount,
          send_status,
          alias_status,
          created_at,
          submit_time,
        } = v;
        return [
          task_name,
          settlement_sheet,
          alias_salary_type,
          total_amount,
          total_num,
          actual_amount,
          estimated_tax_amount,
          added_tax_amount,
          succeed_money,
          failed_amount,
          send_status,
          alias_status,
          created_at,
          submit_time,
        ];
      });
    },
    normalizeAmount(value) {
      const amount = Number(value);
      return Number.isNaN(amount) ? 0 : amount;
    },
    normalizeTableItem(item = {}) {
      const totalAmount = this.normalizeAmount(item.total_amount);
      const nowTaxMoney = this.normalizeAmount(item.now_tax_money);
      const addedTaxMoney = this.normalizeAmount(item.added_tax_money);
      const actualAmount = totalAmount - nowTaxMoney - addedTaxMoney;
      return {
        ...item,
        task_name: item.remark || item.mission_title || item.name || "-",
        settlement_sheet: item.settlement_period || "-",
        settlement_file_url: item.file_url || "",
        actual_amount:
          item.total_amount === undefined || item.total_amount === null
            ? "-"
            : actualAmount,
        estimated_tax_amount:
          item.now_tax_money === undefined || item.now_tax_money === null
            ? "-"
            : item.now_tax_money,
        added_tax_amount:
          item.added_tax_money === undefined || item.added_tax_money === null
            ? "-"
            : item.added_tax_money,
        succeed_money:
          item.succeed_money === undefined || item.succeed_money === null
            ? "-"
            : item.succeed_money,
        failed_amount:
          item.failed_money === undefined || item.failed_money === null
            ? "-"
            : item.failed_money,
        send_status:
          item.send_status === undefined || item.send_status === null || item.send_status === ""
            ? "-"
            : item.send_status,
        submit_time: item.updated_at || "-",
        total_num:
          item.total_num === undefined || item.total_num === null
            ? "-"
            : String(item.total_num),
      };
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1;
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == "all") {
        this.searchCondition.status = tab.name;
        this.init("all");
      } else if (tab.name == "cancel") {
        this.searchCondition.status = tab.name;
        this.init("cancel");
      }
      this.resetPage();
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应详情按钮
    async viewButton(id, type = "") {
      if (type == "") {
        type = "view";
      }
      this.mxRedirect(this.$route.path + "/" + id + "/" + type);
    },
    // 操作按钮相关事件
    async changeStatus(id, type) {
      // 作废结算单
      if (type == "cancel") {
        this.handleCancel({
          id: id,
          type: type,
        });
      }
    },
    // 作废结算单
    async handleCancel({ id, type }) {
      const res = await this.$api.getTaskMissionList({
        type: type,
        batch_id: id,
      });
      if (res) {
        this.$message.success("操作成功。");
        this.init();
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type) {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages, permission } = await this.$api.getTaskMissionList(
        searchCondition,
      );
      this.dataList = [];
      const normalizedList = list.map((item) => this.normalizeTableItem(item));
      this.$nextTick(() => {
        this.dataList = normalizedList;
        this.signTipsInfo = permission;
        // this.signTipsInfo.type = 1;
        // this.signTipsInfo.message = ["请先上传业务结算清单，联系客服","lllll","ppppppp"]
        for (var i = 0; i < this.signTipsInfo.message.length; i++) {
          if (i != 0) {
            this.description.push(this.signTipsInfo.message[i]);
            this.description = [...new Set(this.description)];
          } else {
            this.tipsTitle = this.signTipsInfo.message[i];
          }
        }
        switch (this.signTipsInfo.type) {
          case 0:
            this.dialogData.visible = false;
            break;
          case 1:
            this.dialogData.visible = true;
            this.fontType = "warning";
            break;
          case 2:
            this.isShow = true;
            this.dialogData.visible = true;
            this.fontType = "error";
            break;
          default:
            break;
        }
      });
      this.pagingData.total = pages.total;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.salary_type) {
        condition.salary_type = this.searchCondition.salary_type;
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      if (this.signTipsInfo.type == 2) {
        this.disabled = true;
      }
    },

    keyupSubmit() {
      document.onkeydown = () => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.el-button + .el-button {
  margin-left: 0;
}

::v-deep .el-form-item {
  margin-bottom: 10px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0;
  margin-right: 12px;
}

.iconBtns {
  font-size: 20px;
  color: rgba(0, 183, 158, 1);
}

.warning-tips {
  padding: 15px 5px 25px;
  color: #e6a23c;
  font-size: 16px;
}

.error-tips {
  padding: 15px 5px 25px;
  font-size: 16px;
}

.filterBlur {
  filter: blur(5px);
  -moz-filter: blur(5px);
  -webkit-filter: blur(5px);
}

::v-deep .el-alert__icon {
  font-size: 45px;
  margin-left: -15px;
}

::v-deep .el-alert__content {
  margin-left: 40px;
}

::v-deep .el-alert__title {
  font-size: 16px;
  line-height: 30px;
}

::v-deep .el-alert {
  padding: 0 25px;
}

::v-deep .el-alert--error.is-light,
::v-deep .el-alert--warning.is-light {
  background: #fff;
}

::v-deep .el-alert__title.is-bold {
  font-weight: normal;
}

::v-deep .el-alert__description {
  font-size: 16px;
}

.tips-center {
  justify-content: center;
}
</style>
